import { render, staticRenderFns } from "./Worksheets.vue?vue&type=template&id=52d2ac36&scoped=true&"
import script from "./Worksheets.vue?vue&type=script&lang=js&"
export * from "./Worksheets.vue?vue&type=script&lang=js&"
import style0 from "./Worksheets.vue?vue&type=style&index=0&id=52d2ac36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2ac36",
  null
  
)

export default component.exports